export default import.meta.ROLLDOWN_FILE_URL_e4KNQ9jK6Qxf3UTzHQBM_Q